import React, { Component } from 'react';
import $ from "jquery";

class Result extends Component {
    
    
    componentDidMount = () => {
        this.height();
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }
    
    resize = () => {
        this.height();
    }

    height = () => {    
        let totalHeight = $(window).height();
        let heightHeader = $(".header").outerHeight();
        
        let available = totalHeight - heightHeader + "px";
        document.querySelector(".result").style.height = available;
    }
    
    renderContent = () => {
        let content;
        if (this.props.result) {
            let str = this.props.result.replaceAll('\\n', ' ');
            content =   <div className="card result-card">
                            <div className="card-header"style={{padding: "15px", fontSize: "1.25rem", fontWeight: "900"}}>Resultaat</div>
                            <div className="card-body" style={{padding: "30px"}}>
                                {str}
                            </div>
                        </div>;
        } else {
            content = <div className="loader"></div>;
        }
        return content;
    }

    render() {
        return (
            <div className="result">
                {this.renderContent()}
            </div>
        );
    }
}

export default Result;